module.exports = __webpack_public_path__ + "static/media/alert-and-notification.96ca7e8a.png";